import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TxItem from '../tx-item';
import txStyle from '../tx.module.scss';
const TYPE_ORDER = { income: 0, savings: 1, expense: 2 };
export default function TxSection({ title, transactions, currency, budget, onConfirm, onUnconfirm, onSetCat, onDelete, onEditSeries, onEditTx }) {
    if (transactions.length === 0)
        return null;
    const sorted = [...transactions].sort((a, b) => (TYPE_ORDER[a.type] ?? 9) - (TYPE_ORDER[b.type] ?? 9));
    return (_jsxs("div", { className: txStyle['tx-section'], children: [_jsx("div", { className: txStyle['tx-section-title'], children: title }), sorted.map(tx => (_jsx(TxItem, { tx: tx, currency: currency, budget: budget, onConfirm: onConfirm, onUnconfirm: onUnconfirm, onSetCat: onSetCat, onDelete: onDelete, onEditSeries: onEditSeries, onEditTx: onEditTx }, tx.id)))] }));
}
